import React, { useEffect, useState } from "react"
import { Button, ButtonRow } from "./GambleComponentsStyled"
import { GAMBLE_BUTTON_PROPS } from "./interface"
import { stepDoubleUp } from "../../../../components/functions/gameFunctions"

export default function GambleButton({
  suits,
  sliceA,
  sliceB,
  stateRound,
  audioUrl,
  sendSocketMessage,
  cashout,
  handleCashout,
}: GAMBLE_BUTTON_PROPS) {
  const [anim, setAnim] = useState<string>("")
  const [clickableAction, setClickableAction] = useState<boolean>(true)

  const actionHandler = (name: string) => {
    handleCashout(true)
    setClickableAction(false)
    audioUrl.pick()
    setAnim(name)
    stepDoubleUp(name, sendSocketMessage)
  }

  useEffect(() => {
    if (stateRound.state === 4) {
      setTimeout(() => {
        handleCashout(false)
        setClickableAction(true)
        setAnim("")
      }, 500)
    } else {
      setTimeout(() => {
        setAnim("")
      }, 500)
    }
  }, [stateRound, handleCashout])
  return (
    <ButtonRow>
      {suits.slice(sliceA, sliceB).map((suit: any, id: number) => (
        <Button
          className={suit.name}
          background={suit.color}
          isClickable={stateRound.state === 4 && clickableAction}
          onClick={() => {
            !cashout && actionHandler(suit.name)
          }}
          key={id}
          anim={anim === suit.name && stateRound.state === 4}
          width={suit.width ? suit.width : "56px"}
          height={suit.height ? suit.height : "56px"}
        >
          {suit.icon}
        </Button>
      ))}
    </ButtonRow>
  )
}
